import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

export const BASE_DIALOG_IMPORTS = [
  MatButton,
  MatDialogActions,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatProgressSpinner,

  SafeHtmlPipe,
] as const;

export const PROMPT_DIALOG_IMPORTS = [
  ...BASE_DIALOG_IMPORTS,
  MatFormField,
  MatInput,
  MatError,
] as const;
